import browserHistory from 'shared/history';
import req from 'shared/req';
import {flashMessage} from 'shared/actions/notifications';
import {REMOVE_STUDENT} from 'educator/action-types/students';

export const removeConnection = () => (dispatch, getState) => {
  const {student} = getState();

  return req({
    url: '/rest/educator_invitations/',
    method: 'delete',
    data: {student_id: student._id},
  }).then(() => {
    dispatch({
      type: REMOVE_STUDENT,
      student,
    });
    // TO DO: should be generalized for other user cases...
    browserHistory.push('/educators/students');
    dispatch(flashMessage('Success! You have removed that connection'));
  });
};

export const reportUser =
  ({identifier, message = ''}) =>
  (dispatch) =>
    req({
      url: '/rest/user_reports',
      method: 'post',
      data: {
        reported_id: identifier,
        message,
      },
    }).then(() => {
      dispatch(
        flashMessage('Thank you, the person has been reported and we will look into their account')
      );
    });
